module.exports = __webpack_public_path__ + "static/0045-300w-c828a8d8b7aa43f8a4bf65e240459386.jpg";